<template>
    <div v-if="view">
        <div class="mt-3 row">
            <div class="col-md-10 offset-md-1">
                <h4 style="font-weight:100" class="font-en mt-0 mb-0">
                    <b-link
                        :to="{
                            name: 'IC Service'
                        }"
                        class="mr-3"
                    >
                        <i class="fa fa-arrow-left fa-lg" aria-hidden="true"></i>
                    </b-link>
                    &nbsp;New Support Ticket <!-- {{ this.$route.query.category }} @submit.prevent="sendProblemRequest" -->
                </h4>
                <small class="mt-0 ml-5">Create Ticket request problem.</small>
                <b-card class="mt-3">
                    <b-card-body>
                        <b-form class="mt-0">
                            <label style="color:#66615b;" class="mt-0 font-en"><i class="fa fa-caret-right" aria-hidden="true"></i>Category <span class="text-danger">*</span></label>
                            <Select2
                                class="font-en"
                                v-model="formData.typeProblem"
                                :options="optionsSelectProblem"
                                :settings="{ placeholder:'Please select Category',width:'100%' }"
                            />
                            <label style="color:#66615b;" class="mt-3 font-en"><i class="fa fa-caret-right" aria-hidden="true"></i>Subject <span class="text-danger">*</span></label>
                            <b-form-group>
                                <b-form-input
                                    class="font-en"
                                    type="text"
                                    placeholder="Enter Issues to be reported"
                                    v-model="formData.titleProblem"
                                    autocomplete="off" trim
                                ></b-form-input>
                            </b-form-group>
                            <label style="color:#66615b;" class="font-en"><i class="fa fa-caret-right" aria-hidden="true"></i>Description <span class="text-danger">*</span></label>
                            <b-form-textarea
                                placeholder="Enter Detail..."
                                rows="3"
                                max-rows="6"
                                v-model="formData.descriptionProblem"
                                class="font-en"
                                autocomplete="off" trim
                            ></b-form-textarea>
                            <label style="color:#66615b;" class="font-en mt-2"><i class="fa fa-caret-right" aria-hidden="true"></i>Email <span class="text-danger">*</span></label>
                            <b-form-group
                                description="Please enter a valid email address so our staff can reach you."
                                :state="isMail"
                                invalid-feedback="Bad email format"
                            >
                                <b-form-input
                                    class="font-en"
                                    type="email"
                                    placeholder="Enter email"
                                    v-model="formData.mailContact"
                                    :state="isMail"
                                    autocomplete="off" trim
                                ></b-form-input>
                            </b-form-group>
                            <label style="color:#66615b;" class="font-en">
                                <i class="fa fa-caret-right" aria-hidden="true"></i>Phone number
                            </label>
                            <b-form-group
                                :state="isTel"
                                invalid-feedback="Bad Mobile Phone format"
                                description="Not necessary ex: 0800547169"
                            >
                                <b-form-input
                                    size="sm"
                                    class="font-en"
                                    maxlength="10"
                                    type="text"
                                    placeholder="Enter Phone number"
                                    v-model="formData.phoneContact"
                                    :state="isTel"
                                    autocomplete="off" trim
                                ></b-form-input>
                            </b-form-group>
                            <b-button
                                class="mb-3"
                                :disabled="!isFormValid"
                                @click="sendProblemRequest"
                                block variant="success"
                            ><i class="fa fa-paper-plane" aria-hidden="true"></i>Submit</b-button>
                        </b-form>
                        <br>
                        <span v-if="output !== null" class="text-danger">
                            {{ output }}
                        </span>
                    </b-card-body>
                </b-card>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .form-control {
        background-color: #ffffff;
        border: 1px solid #ced4da;
        border-radius: 4px;
        color: #000;
        font-size: 14px;
        transition: background-color 0.3s ease 0s;
        padding: 7px 18px;
        height: 40px;
        -webkit-box-shadow: none;
        box-shadow: none;
    }
    .font-en{ font-family: 'Rubik', sans-serif; }
</style>

<style>
    .select2-container .select2-selection--single {
        box-sizing: border-box;
        cursor: pointer;
        display: block;
        height: 40px;
        user-select: none;
        -webkit-user-select: none;
    }
    .select2-container--default .select2-selection--single .select2-selection__rendered {
        color: #444;
        line-height: 38px;
        font-size: 16px;
    }
</style>

<script>
    const formProblem = {
        titleProblem:'',
        descriptionProblem:'',
        typeProblem:'',
        phoneContact:'',
        mailContact:'',
    }
    const validateEmail = email => {
        //eslint-disable-next-line
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };
    const validateTel = tel => {
        //eslint-disable-next-line
        var re = /^[0-9]*$/;
        return re.test(String(tel));
    };
    import Select2 from 'v-select2-component';
    export default {
        components: { Select2 },
        props: {},
        data() {
            return { 
                view:false,
                output:null,
                formData: Object.assign({}, formProblem),
                optionsSelectProblem:[],
            }
        },
        computed: {
            isMail() {
                if (this.formData.mailContact === "") return null;
                return validateEmail(this.formData.mailContact);
            },
            isTel() {
                if (this.formData.phoneContact === "") return null;
                return validateTel(this.formData.phoneContact);
            },
            isFormValid(){
                if (this.formData.titleProblem !== '' && this.formData.descriptionProblem !== '' && this.formData.typeProblem !== '' && validateEmail(this.formData.mailContact) && validateTel(this.formData.phoneContact)) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        mounted(){
            this.checkMsgWhoAmi()
            this.optionApi()
            this.formData.mailContact = this.$keycloak.tokenParsed.email
        },
        methods: {
            checkMsgWhoAmi(){
                var count = 0
                var arr = ['faculty','staff','student']
                for (let index = 0; index < this.$store.state.permit.RulesUser.roles.length; index++) {
                    if(arr.includes(this.$store.state.permit.RulesUser.roles[index])){
                        count++
                    }
                    // console.log(this.$route.meta.permitC.includes(this.$store.state.permit.RulesUser.roles[index]))
                }
                if(count == 0){
                    this.$router.push("/accountpermit").catch(err => {})
                }else{
                    this.view = true
                }
                // console.log(count)
            },
            mapQueryChoice(valQuery){
                if(valQuery !== '' && valQuery !== null && valQuery !== 0){
                    var ValueTxt =  []
                    ValueTxt = this.optionsSelectProblem.filter( (item)  => {
                        return item.id == valQuery;
                    }).map(itemX => {
                        return  itemX.id
                    })
                    this.formData.typeProblem = ValueTxt[0]
                }else{
                    this.formData.typeProblem = ''
                }
            },
            async optionApi(){
                this.output = null
                try {
                    this.optionsSelectProblem = []
                    const res = await this.$http.get('/ticket/type/')
                    if(res.status === 200){
                        this.optionsSelectProblem =  res.data.map(item => {
                            return {
                                'id':item.id,
                                'text':item.detail,
                                'view_order':item.view_order,
                            }
                        })
                        this.optionsSelectProblem.sort((a, b) => {
                            return b.view_order - a.view_order;
                        });
                        //
                        this.mapQueryChoice(this.$route.query.category)
                    }
                } catch (error) {
                    this.output = error
                }
            },
            async sendProblemRequest(){
                this.output = null
                const sendDataProblem = new FormData()
                sendDataProblem.append('topic', this.formData.titleProblem)
                sendDataProblem.append('message', this.formData.descriptionProblem)
                sendDataProblem.append('ticket_type', this.formData.typeProblem)
                sendDataProblem.append('contact_phone', this.formData.phoneContact)
                sendDataProblem.append('contact_mail', this.formData.mailContact)
                try {
                    const response = await this.$http.post('/ticket/request/', sendDataProblem,{
                        headers: { 'Content-Type': 'multipart/form-data' }
                    })
                    if(response.status === 201){
                        try {
                            const sendMsgComment = new FormData()
                            // sendMsgComment.append('id', response.data.id)
                            sendMsgComment.append('msg_type', 'ask')
                            sendMsgComment.append('message', this.formData.descriptionProblem)
                            sendMsgComment.append('upload_file', null)
                            const resCreateMsg = await this.$http.post(`/ticket/msg/push/${response.data.id}/`, sendMsgComment,{
                                headers: { 'Content-Type': 'multipart/form-data' }
                            })
                            if(resCreateMsg.status === 201){
                                this.formData = Object.assign({}, formProblem)
                                this.output = null
                                this.$router.replace('/icservice')
                            }else{
                                throw { resCreateMsg }
                            }
                        } catch (error2) {
                            this.output = `Add massage : `+error2
                            this.formData = Object.assign({}, formProblem)
                            this.output = null
                            this.$router.replace('/icservice')
                        }
                    }else{
                        throw { response }
                    }
                } catch (error) {
                    this.output = `Add ticket : `+error
                }
            }
        }
    }
</script>